import { render } from "./UserFaqIcon.vue?vue&type=template&id=4ce1b13c&scoped=true"
import script from "./UserFaqIcon.vue?vue&type=script&lang=js"
export * from "./UserFaqIcon.vue?vue&type=script&lang=js"

import "./UserFaqIcon.vue?vue&type=style&index=0&id=4ce1b13c&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce1b13c"]])

export default __exports__